import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntities as getFleets } from 'app/entities/fleet/fleet.reducer';
import { getEntities as getStations } from 'app/entities/station/station.reducer';
import { DeviceType } from 'app/shared/model/enumerations/device-type.model';
import { createEntity, getEntity, updateEntity } from './device.reducer';

export const DeviceUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const fleets = useAppSelector(state => state.fleet.entities);
  const stations = useAppSelector(state => state.station.entities);
  const deviceEntity = useAppSelector(state => state.device.entity);
  const loading = useAppSelector(state => state.device.loading);
  const updating = useAppSelector(state => state.device.updating);
  const updateSuccess = useAppSelector(state => state.device.updateSuccess);
  const deviceTypeValues = Object.keys(DeviceType);

  const handleClose = () => {
    navigate('/device');
  };

  useEffect(() => {
    if (!isNew) {
      dispatch(getEntity(id));
    }

    dispatch(getFleets({}));
    dispatch(getStations({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  // eslint-disable-next-line complexity
  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.vendorData) {
      values.vendorData = JSON.parse(values.vendorData);
    }

    const entity = {
      ...deviceEntity,
      ...values,
      fleet: fleets.find(it => it.id.toString() === values.fleet?.toString()),
      station: stations.find(it => it.id.toString() === values.station?.toString()),
      stationId: values.station,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? { vendorData: '{}' }
      : {
          type: 'SMART_LOCK',
          ...deviceEntity,
          vendorData: deviceEntity?.vendorData ? JSON.stringify(deviceEntity.vendorData, null, 2) : '{}',
          fleet: deviceEntity?.fleet?.id,
          station: deviceEntity?.station?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="cabmanApp.device.home.createOrEditLabel" data-cy="DeviceCreateUpdateHeading">
            <Translate contentKey="cabmanApp.device.home.createOrEditLabel">Create or edit a Device</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="device-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField label={translate('cabmanApp.device.type')} id="device-type" name="type" data-cy="type" type="select">
                {deviceTypeValues.map(deviceType => (
                  <option value={deviceType} key={deviceType}>
                    {translate('cabmanApp.DeviceType.' + deviceType)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('cabmanApp.device.serialNumber')}
                id="device-serialNumber"
                name="serialNumber"
                data-cy="serialNumber"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 64, message: translate('entity.validation.maxlength', { max: 64 }) },
                }}
              />
              <ValidatedField
                label={translate('cabmanApp.device.model')}
                id="device-model"
                name="model"
                data-cy="model"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 32, message: translate('entity.validation.maxlength', { max: 32 }) },
                }}
              />
              <ValidatedField
                label={translate('cabmanApp.device.name')}
                id="device-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  maxLength: { value: 64, message: translate('entity.validation.maxlength', { max: 64 }) },
                }}
              />
              <ValidatedField
                label={translate('cabmanApp.device.vendorData')}
                id="device-vendorData"
                name="vendorData"
                data-cy="vendorData"
                type="textarea"
              />
              <ValidatedField id="device-fleet" name="fleet" data-cy="fleet" label={translate('cabmanApp.device.fleet')} type="select">
                <option value="" key="0" />
                {fleets
                  ? fleets.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="device-station"
                name="station"
                data-cy="station"
                label={translate('cabmanApp.device.station')}
                type="select"
              >
                <option value="" key="0" />
                {stations
                  ? stations.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/device" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DeviceUpdate;
